import quemSomosImg from '../../../assets/img/artigos/quem_somos_icon.svg';
import martaEscutaImg from '../../../assets/img/artigos/marta_escuta_icon.svg';
import doacoesImg from '../../../assets/img/artigos/doacoes_icon.svg';
import PixCopyButton from '../CopyButton';

const aboutArticlesData = [
  {
    // C2
    id: 'quem-somos',
    href: '/artigos/quem-somos',
    title: 'Quem somos?',
    type: 'Sobre a associação',
    image: quemSomosImg,
    iconRef: 'artigos',
    text: (
      <>
        <p>
          Somos uma organização formada por mulheres que atuam no enfrentamento à violência
          estrutural contra a mulher.
        </p>
        <p>
          Nossa missão é conscientizar, educar e empoderar estudantes e a comunidade para se
          tornarem cidadãos mais responsáveis, conscientes e sensíveis ao tema. Além de oferecer
          assistência jurídica e escuta psicológica gratuita às vítimas de violência.
        </p>
        <p>
          A Associação Marta leva este nome em homenagem a uma mulher anônima que, assim como
          muitas, já sofreu com a violência doméstica, mas que tem uma história inspiradora de
          superação. Fundada em 2019 por 5 amigas que possuem o mesmo sonho em comum: colaborar com
          o enfrentamento à violência contra mulher.
        </p>
        <p>
          Somos uma Associação composta por mulheres, que enfatizam a causa das vítimas da violência
          estrutural da sociedade, atuando na sua prevenção e conscientização. Além de realizarmos
          palestras virtuais e presenciais, temos forte presença nas redes sociais com o objetivo de
          conscientizar e educar os estudantes e a comunidade, a fim de que se tornem cidadãos mais
          responsáveis, sensíveis aos temas relacionados à causa da Associação.
        </p>
        <p>
          Também promovemos projetos de assistência jurídica e psicológica gratuitas para vítimas de
          violência contra a mulher. Utilizamos de exemplos práticos e linguagem de fácil
          entendimento para que a mensagem seja entendida pelo maior número possível de pessoas.
        </p>
        <p>
          As palestras e os atendimentos jurídicos e psicológicos são realizados por nossas
          associadas, previamente selecionadas e treinadas, com familiaridade sobre o assunto e o
          público-alvo.
        </p>
        <br />
        <p>
          <b>Quem é Marta?</b>
        </p>
        <p>
          Ela pode ser você. Ela pode ser a mulher ao seu lado. Ela pode ser a mulher que sofre
          violência enquanto você lê estas palavras. Ela é uma, mas pode ser muitas. Ela, assim como
          todas nós, conseguiu encontrar uma maneira de mudar o rumo de sua vida. Sentiu que
          enquanto havia chão para ela pisar, reuniria forças para lutar.{' '}
        </p>
        <p>
          Marta Sarmento Bispo aprendeu desde nova que homens e mulheres exercem papéis diferentes
          na sociedade. Por isso, quando conheceu seu ex-companheiro, normalizou que a sua vida
          seria de muita batalha e que ela seria a única responsável pela felicidade do lar,
          independente do que acontecesse.
        </p>
        <p>
          No início, o relacionamento entre eles era um sonho. Ela foi a escolhida pelo rapaz
          popular, engraçado, boa companhia e bonito. Sentia que, naquele momento, estava realizada.
          Sua família, satisfeita, entregou a filha ao que eles esperavam ser um bom genro. Talvez,
          um novo filho. Mas, apesar de qualquer dúvida, havia uma certeza: ela seria a esposa que
          aprendeu a idealizar.
        </p>
        <p>
          No entanto, não durou muito até que o oásis entre eles começasse a secar. Mas, assim como
          nas histórias de terror, o vilão nos envolve em uma trama e nos deixa presa em um
          labirinto de emoções difícil de escapar. Ao passo que Marta experimentava um momento
          especial como a maternidade, foi obrigada a suportar as agruras de um homem ensandecido
          que exigia cada vez mais de uma mulher que já lhe entregava a própria existência.
        </p>
        <p>
          Pediu socorro em todos os locais em que acreditou ser possível buscar acolhimento e
          proteção, mas encontrou apenas indiferença e abandono. Felizmente, tinha certeza de que
          não estava destinada a viver uma vida de dor e sofrimento, mas não encontrava meios para
          emergir e sair para um novo caminho. Na solidão da dor, viveu mais 22 anos com o homem que
          lhe deu quatro filhos. Afinal, nascem flores até no deserto. Tentou algumas vezes decidir
          seu próprio rumo, daí ela percebeu que uma decisão sempre comportará dificuldades em todo
          o seu percurso de desenvolvimento. Conseguia sair dele, mas resistir depois da saída era
          muito complexo. Por isso, sucumbia e voltava.
        </p>
        <p>
          Foram anos de sofrimento, experimentou a dor física e psicológica em escalas que jamais
          poderemos descrever, apenas quem experimenta sabe. Não fraquejou diante do luto dos
          próprios sonhos, o afastamento dos filhos, ocasionado propositalmente pelo pai deles,
          talvez tenha sido um dos momentos mais difíceis, mas, depois de todas as provações, ela
          sabia que a única saída era resistir.
        </p>
        <p>
          Após tantos anos afrontando as adversidades, Marta conseguiu mudar. Alcançou sonhos que
          estavam longe e que, em muitos momentos, pareciam inatingíveis. Felizmente, ela conseguiu
          reescrever seu futuro, tornando-se autora da própria história. Conseguiu a guarda dos
          filhos, alcançou independência profissional e, principalmente, alforriou seu autoamor.
          Hoje, tem satisfação e sede de viver.
        </p>
        <p>
          Aqui, celebramos Marta pelo desfecho feliz após grandes passagens de sofrimento. A vida
          venceu. Finalmente. Porém, poderíamos ter muitos finais inesperados, alguns mais felizes,
          ou até mais tristes. Por esse motivo, nasceu a Associação Marta.
        </p>
      </>
    ),
  },
  {
    // C3
    id: 'marta-escuta',
    href: '/artigos/marta-escuta',
    title: 'Marta Escuta',
    type: 'Sobre a associação',
    image: martaEscutaImg,
    iconRef: 'artigos',
    text: (
      <>
        <p>
          Durante o Marta Escuta, por intermédio de profissionais capacitadas, a Associação Marta
          disponibilizará os serviços de assessoria jurídica e de escuta solidária, de maneira
          completamente GRATUITA e remota, às mulheres vítimas de violência, em qualquer lugar do
          Brasil.
        </p>
        <b>Assessoria jurídica</b>
        <p>
          A assessoria jurídica é realizada por Advogadas capacitadas inscritas na OAB, em que é
          ofertado <b>suporte jurídico</b> para que mulheres vítimas de violência conheçam seus
          direitos e possibilidades com <b>segurança e sigilo</b>, incluindo informações sobre
          Divórcio, guarda de filhos, alimentos, boletim online, medidas protetivas etc., com os
          respectivos alinhamentos judiciais.
        </p>
        <b>Escuta solidária</b>
        <p>
          É um <b>serviço de escuta</b>, realizado por Psicólogas capacitadas inscritas no CRP, às
          mulheres vítimas de violência possibilitando um espaço de fala em que elas{' '}
          <b>se sintam acolhidas</b> e possam externalizar suas angústias, oferecendo uma{' '}
          <b>rede de apoio segura e sigilosa</b>.
        </p>
        <b>Quem pode ser atendida?</b>
        <p>
          Mulheres que sofrem ou já sofreram algum tipo de violência e estejam interessadas nos
          serviços da campanha.
        </p>
        <b>Como posso participar?</b>
        <p>
          É possível participar realizando um agendamento disponível na página de{' '}
          <a href="/artigos/atendimentos">
            <stan style={{ color: '#337066' }}>Atendimento</stan>
          </a>
          , para saber melhor sobre como fazer um agendamento basta clicar aqui (vai pra página
          explicando sobre a tela de atendimento).
        </p>
      </>
    ),
  },
  {
    // C4
    id: 'doacoes',
    href: '/artigos/doacoes',
    title: 'Doações',
    type: 'Sobre a associação',
    image: doacoesImg,
    iconRef: 'artigos',
    text: (
      <>
        <p>
          Gostaria de ajudar a Associação Marta a crescer? Você pode fazer uma doação via Pix.
          Fazendo isso você ajuda a alcançar mulheres em situação de vulnerabilidade e contribui em
          um papel de ruptura de um ciclo de violência.
        </p>
        <p>
          Doações via Pix por: <br />
          <PixCopyButton pixCode="61.295.659/0001-07" />
        </p>
      </>
    ),
  },
];

export default aboutArticlesData;
